<ng-container *ngIf="isLoading$ | async"></ng-container>
<ngx-spinner></ngx-spinner>
<div class="page-title-area page-title-four">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="page-title-item">
        <h2> {{'MENU.OFFERS' | translate}} </h2>
        <ul>
          <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
          <li><i class="icofont-simple-right"></i></li>
          <li>{{'MENU.OFFERS' | translate}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>


<div class="appointment-area-two" style="margin-top: 500px;margin-bottom: -115px;"></div>


<!-- <section class="appointment-area-two">
  <div class="container">
      <div class="row align-items-center appointment-wrap-two">
          <div class="col-lg-12 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
              <div class="appointment-item appointment-item-two ">
                  <div class="text-center">
                      <h2 style="font-weight: bold;font-size: 34px;">{{ language == 'en' ? EnvService.OffersHeaderEn : EnvService.OffersHeaderAr}}</h2>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<section class="doctors-area " style="margin-top: -140px;">
  <div class="container text-center">
      <div class="slider-container" *ngFor="let section of offers; let sectionIndex = index">
        <h1 style="margin: 10px;">{{ language =='ar' ? section.nameAr : section.nameEn }}</h1>
      <hr>
        <div class="slides-wrapper">
          <div class="slides" [style.transform]="getTransform(sectionIndex)">
            <div class="slide" *ngFor="let Images of section.apiOfferImages" >
              
              <img [routerLink]="'/registerinfo/'+ section.id+'/'+Images.id+'/'+AppId" 
              *ngIf="Images.imagePath != null && Images.imagePath !='' ;else NewsImagePath" 
              [src]="Images.imagePath | SafeUrlPipe"
                alt="offers"  (click)="TrackOffer('Press Offer',Images.id,section.id)" >
                <ng-template #NewsImagePath><a></a></ng-template>

            </div>
          </div>
        </div>
      
        <button  class="prev" (click)="prevSlide(sectionIndex,section.id)" *ngIf="section.apiOfferImages.length > 1 " >
          <span *ngIf="language == 'en'"> ❮</span>
          <span *ngIf="language == 'ar'">❯</span>
        </button>
        <button class="next" (click)="nextSlide(sectionIndex,section.id)" *ngIf="section.apiOfferImages.length > 1">
         
          <span *ngIf="language == 'en'"> ❯</span>
          <span *ngIf="language == 'ar'">❮</span>
        </button>
        <div class="row text-center" >
          <div class="common-btn" style="margin-top: 20px;">
            <button class="custom-btn btn-12" [routerLink]="'/registerinfo/'+ section.id+'/'+AppId" (click)="TrackOffer('Press Book Now',null,section.id)">
              <span style="width: 200px !important;">{{ language == 'en'? 'Book Now': 'احجز الآن' }}</span><span
                style="width: 200px !important;">{{ language == 'en'? 'Book Now': 'احجز الآن' }}</span>
            </button>
          </div>
      </div>
     
    
      </div>
  </div>
</section> -->